export interface ExpertiseComponentState {
    quickSearchText: string;
}

export const initialExpertiseComponentState: ExpertiseComponentState = {
    quickSearchText: '',
};
